import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { element: String }
  }

  connect() {
    document.querySelector(this.elementValue).classList.add("d-none")
    this.element.remove()
  }
}
